// DadosDo Grupo

import React, { useEffect, useState } from 'react';
import { useClientNavigation } from '../hooks/useClientNavigation.mjs';
import { apiUrl } from '../api/client.mjs'; // Certifique-se de que o caminho está correto
import { styles } from '../styles/personalizacao.mjs';
import axios from 'axios';

const DadosDoGrupo = () => {
    const [dadosDoGrupo, setDadosDoGrupo] = useState({
        nomeGrupo: '',
        mensagemPersonalizada: '',
        mensagemFinal: '',
        mensagemDeDez: '',
        mensagemBoasVindas: '',
        boasVindasAtiva: false,
        msgHorarios: false,
        msgRec: false,
        msgVendas: false,
        antispan: false,
        sorteativa: false
    });

    const { navigateToClient } = useClientNavigation();
    const clienteId = process.env.REACT_APP_CLIENT_ID;

    useEffect(() => {
        const fetchDadosDoGrupo = async () => {
            try {
                const response = await axios.get(apiUrl(`dados-do-grupo`));
                const data = response.data[0];

                setDadosDoGrupo({
                    nomeGrupo: data.nome_grupo || '',
                    mensagemPersonalizada: data.mensagem_personalizada || '',
                    mensagemFinal: data.mensagem_final || '',
                    mensagemDeDez: data.mensagem_de_dez || '',
                    mensagemBoasVindas: data.mensagemboasvindas || '',
                    msgHorarios: data.msg_horarios === 'true' || data.msg_horarios === true,
                    msgRec: data.msg_rec === 'true' || data.msg_rec === true,
                    msgVendas: data.msg_vendas === 'true' || data.msg_vendas === true,
                    boasVindasAtiva: data.boasvindasativa === 'true' || data.boasvindasativa === true,
                    antispan: data.antispan === 'true' || data.antispan === true,
                    sorteativa: data.sorteativa === 'true' || data.sorteativa === true
                });
            } catch (error) {
                console.error('Erro ao buscar dados do grupo:', error);
            }
        };

        fetchDadosDoGrupo();

    }, [clienteId]);

    const handleEditClick = () => {
        navigateToClient('/formData');
    };
    console.log(dadosDoGrupo.boasVindasAtiva);
    return (
        <div style={styles.container}>
            <h2 style={styles.titulo}>Dados do Grupo</h2>
            <span style={styles.descricao}>Aqui, você cadastra os dados do seu grupo para personalização.</span>
            <div style={styles.detalhesGrupo}>
                <p>Nome do Grupo: {dadosDoGrupo.nomeGrupo}</p>
                <p>Mensagem Personalizada: {dadosDoGrupo.mensagemPersonalizada}</p>
                <p>Mensagem Final: {dadosDoGrupo.mensagemFinal}</p>
                <p>Lista de plataformas trabalhadas: {dadosDoGrupo.mensagemDeDez}</p>
                <p>Mensagem de Boas Vindas: {dadosDoGrupo.mensagemBoasVindas}</p>
                <div>
                    <h2>Ferramentas ativas em seu grupo</h2>
                    <span>Horários: {dadosDoGrupo.msgHorarios ? "🟢 Ativado" : "🔴 Desativado"} </span><br />
                    <span>Promoções: {dadosDoGrupo.msgRec ? "🟢 Ativado" : "🔴 Desativado"} </span><br />
                    <span>Lançamentos: {dadosDoGrupo.msgVendas ? "🟢 Ativado" : "🔴 Desativado"}</span><br />
                    <span>Boas Vindas: {dadosDoGrupo.boasVindasAtiva ? "🟢 Ativado" : "🔴 Desativado"}</span><br />
                    <span>AntiSpan no grupo: {dadosDoGrupo.antispan ? "🟢 Ativado" : "🔴 Desativado"}</span><br />
                    <span>Msg Sorte no grupo: {dadosDoGrupo.sorteativa ? "🟢 Ativado" : "🔴 Desativado"}</span><br />

                </div>
            </div>
            <button style={styles.botaoEditar} onClick={handleEditClick}>Editar Dados do Grupo</button>
        </div>
    );
};

export default DadosDoGrupo;
